import React from 'react';

interface Props {
  message?: string;
}

export const PageLoading: React.FC<Props> = ({ message }) => {
  return (
    <div className="flex flex-col items-center justify-center h-screen w-full gap-4">
      <progress className="progress progress-primary w-56"></progress>
      {message && <p className="text-base-content/60 font-medium animate-pulse">{message}</p>}
    </div>
  );
};
